import { AfterContentInit, Component, OnInit } from '@angular/core';

import { ThemeConstantService } from '../../services/theme-constant.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { BehaviorSubject } from 'rxjs';
import { User } from '../../models/user';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MsalService } from '@azure/msal-angular';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit{
  searchVisible: boolean = false;
  quickViewVisible: boolean = false;
  isFolded: boolean;
  isExpand: boolean;
  public UserData: any;
  public UserStatus: boolean;
  private userSubject: BehaviorSubject<User>;
  profile:any;

  constructor(
    private themeService: ThemeConstantService,
    public router: Router,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    public jwtHelper: JwtHelperService,
    public msalService: MsalService,
  ) {}

  ngOnInit(): void {
    this.getLoginStatus();
    this.themeService.isMenuFoldedChanges.subscribe(
      (isFolded) => (this.isFolded = isFolded)
    );
    this.themeService.isExpandChanges.subscribe(
      (isExpand) => (this.isExpand = isExpand)
    );

    let ssoToken = this.authenticationService.GetAccessToken();
    this.UserData = this.jwtHelper.decodeToken(localStorage.getItem('accessToken'));
  }


  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
  }

  quickViewToggle(): void {
    this.quickViewVisible = !this.quickViewVisible;
  }



  getLoginStatus(){
    this.UserStatus =  this.authenticationService.loginDisplay;
  
  }

  login(){
    this.authenticationService.loginRedirect();
  }

  logout(){
    localStorage.clear();
    this.authenticationService.logout();
  }
}
